<template>
    <span class="rotation-span"><font-awesome-icon icon="fa-solid fa-rotate" spin /></span>
</template>

<script setup>
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faRotate } from '@fortawesome/free-solid-svg-icons'

    library.add(faRotate)

</script>

<style scoped>
    .rotation-span {
        cursor: pointer;
        transition: 0.5s all ease;
        font-size: 1.2em;
    }

    .rotation-span:hover {
        color: #F56C6C;
    }
</style>